import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SteLib, {POPUP_INITDATA} from 'src/lib/stelib';
import 'dayjs/locale/it';
import { CircularProgress } from '@mui/material';
import ScSeatBookingAdmin from '../scSeatBooking/applicationAdmin'
import BookPopupAdmin from './BookPopupAdmin';

export default function ShowBookPopup({state, successCallback}) {

  const [selectedSeats, setSelectedSeats] = React.useState([]);
  const [BPA_data, BPA_setData] = React.useState(POPUP_INITDATA);

  useEffect(() => {
    if(state?.data?.open && (state?.data?.loading || state?.data?.refresh))
    {
      //INIT POPUP
      setSelectedSeats([]);
      //END LOADING
      state.setData({...state.data, loading: false, refresh: false});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.data?.open]);

  const handleClose = () => {
    state.setData(POPUP_INITDATA);
  };

  let handleSeatClick = (arg) => {
    setSelectedSeats(arg);
  }

  let onReserveSeatsClick = () => {
    BPA_setData({...BPA_data, open: true, seats: selectedSeats, timetableId: state?.data?.timeTable?.id});
  }

  let onDeleteSeatsClick = () => {
    if(window.confirm("Sei sicuro di voler eliminare la prenotazione dei posti selezionati?")){
      SteLib.DeleteRequest("timetables/"+state?.data?.timeTable?.id+"/seats/", {selectedSeats: selectedSeats}, false).then((data) => {
        handleSetPayedDone();
      });
    }
  }

  let onPayedSeatsClick = () => {
    if(window.confirm("Sei sicuro di impostare i posti selezionati come pagati?")){
      SteLib.PutRequest("timetables/"+state?.data?.timeTable?.id+"/seats/setPayed", {selectedSeats: selectedSeats}, false).then((data) => {
        handleSetPayedDone();
      });
    }
  }


  let handleSetPayedDone = () => {
    setSelectedSeats([]);
    successCallback();
  }

  let deletable = () => {
    let rv = selectedSeats.length > 0;
    selectedSeats.map(ss => {
      let found = false;
      state?.data?.timeTable?.seatsBooked.map(sb => {
        if(sb.seatCode === ss)
        {
          found = true;
        }
      })
      if(!found)
      {
        rv = false;
      }
    })
    return rv;
  }

  let reservable = () => {
    console.log(selectedSeats);
    let rv = selectedSeats.length > 0;
    selectedSeats.map(ss => {
      state?.data?.timeTable?.seatsBooked.map(sb => {
        if(sb.seatCode === ss)
        {
          rv = false;
        }
      })
    })
    return rv;
  }

  let payable = () => {
    let rv = selectedSeats.length > 0;
    selectedSeats.map(ss => {
      let found = false;
      state?.data?.timeTable?.seatsBooked.map(sb => {
        if(sb.seatCode === ss && sb.type === 1)
        {
          found = true;
        }
      })
      if(!found)
      {
        rv = false;
      }
    })
    return rv;
  }


  return (
    <>
      <Dialog disablePortal fullWidth maxWidth="sm" open={state?.data?.open} onClose={handleClose}>   
        <DialogTitle>
          Posti prenotati per<br/>
          <small>
          <u>{state?.data?.title}</u>
            <br/>{SteLib.FormatDMYHHMM(state.data?.timeTable?.dateTime)}
          
          </small>
          </DialogTitle>
        <DialogContent >
          {state?.data?.loading ? 
           <div style={{margin: "2rem 0", width: "100%", textAlign: "center"}}><CircularProgress color="inherit" /></div> : 
              <><ScSeatBookingAdmin handleSetPayedDone={handleSetPayedDone} allowSelection={true} notAvailableSeats={state?.data?.timeTable?.seatsBooked} handleClick={handleSeatClick}></ScSeatBookingAdmin>
              
              <div style={{display: "flex"}}>
                <div style={{display: deletable() ? "block": "none"}}>
                  <Button style={{color: "#b72136"}} onClick={onDeleteSeatsClick}>Elimina</Button>
                </div>
                <div style={{display: reservable() ? "block": "none"}}>
                  <Button style={{color: "#ff930f"}} onClick={onReserveSeatsClick}>Riserva</Button>
                </div>
                <div style={{display: payable() ? "block": "none", marginRight: "auto"}}>
                  <Button style={{color: "#6aa84f"}} onClick={onPayedSeatsClick}>Pagato</Button>
                </div>
                <div style={{marginLeft: "auto"}}>
                  <Button onClick={handleClose}>Chiudi</Button>
                </div>
                </div>
              </>
          }
          </DialogContent>
          <BookPopupAdmin state={{data: BPA_data, setData: BPA_setData}} successCallback={handleSetPayedDone/*handleClose*/}></BookPopupAdmin>
      </Dialog>
    </>
  );
}